// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"1e17ba7c","205":"f0a8b944","548":"7fd88d3f","770":"3f65c678"}[chunkId] + ".chunk.js";
};